import PageNotFound from './PageNotFound';

export default PageNotFound;



// WEBPACK FOOTER //
// ./src/components/pageNotFound/index.js